import React from 'react';

import { TransparentContainer } from 'components/common/TransparentContainer';
import { Row, Col } from 'reactstrap';
import { FormatTeams } from 'components/common/FormatTeams';
import { TeamUser } from 'types/teamUser';
import { Avatar } from 'components/common/Avatar/';
import { WebImage } from '../WebImage';
import { Flex } from './atoms/Flex';
import { Section } from './atoms/Section';
import { User } from './atoms/User';
import { Text } from './atoms/Text';

interface Props {
    user?: TeamUser;
    text?: string;
    small?: [];
}

export const TopSection: React.FC<Props> = ({ user, text }) => {
    const { imageAttachments, fullname, teams } = user || {};

    return (
        <Section>
            <TransparentContainer>
                <Row>
                    {user ? (
                        <Col lg={{ size: 8, offset: 2 }}>
                            <Flex>
                                <Avatar size="100px">
                                    <WebImage
                                        image={{
                                            alt: fullname,
                                            ...imageAttachments[0].image,
                                        }}
                                    />
                                </Avatar>
                                <User>
                                    <h5>{fullname}</h5>
                                    <h6>
                                        <FormatTeams teams={teams} />
                                    </h6>
                                </User>
                            </Flex>
                        </Col>
                    ) : text ? (
                        <Col lg={{ size: 8, offset: 2 }}>
                            <Text>{text}</Text>
                        </Col>
                    ) : (
                        ''
                    )}
                </Row>
            </TransparentContainer>
        </Section>
    );
};
